import angular from 'angular';
import './modals/program-capacity';
import moment from 'moment-timezone';
import { schedule } from '../utils';
import { map } from 'lodash';
import '../services/place';
import '../services/notifications';
import '../services/slot-per-time-range';
import '../services/area'

const module = angular.module('whyline.controllers.slotsPerTimeRange', [
    'whyline.modals.program-capacity',
    'whyline.services.place',
    'whyline.services.notifications',
    'whyline.services.slotsPerTimeRange',
    'whyline.services.area',
])

const SlotsPerTimeRangeController = ($scope, $state, $uibModal, $timeout, PlaceService, $translate, NotificationService, SlotsPerTimeRangeService, AreaService, dialog) => {

    $scope.showMoreBtn = false;
    $scope.showLoader = false;
    $scope.areaId = $state.params.areaId;
    $scope.previousArea = {};
    $scope.hasProcessAlready = $scope.areaId ? true : false;
    $scope.applyFilters = false;
    $scope.areas = [];
    $scope.configurations = [];
    $scope.selectedArea = {
        _id: '',
        label: '',
        appointmentsConfiguration: {},
    };
    $scope.place = PlaceService.GetCurrent();
    $scope.alreadyFiltered = false;
    AreaService.GetAllAsPromise().then(areas => {
    $timeout(() => {
        map(areas, area => $scope.areas.push({
            _id: area._id,
            label: area.label,
            appointmentsConfiguration: area.appointmentsConfiguration,
        }));
        if ($scope.hasProcessAlready) {
            $scope.selectedArea = $scope.areas.find(area => area._id === $scope.areaId);
        }
        });
    });
    $scope.hours = schedule.getHour();
    $scope.minutes = schedule.getMinutesByParam(15);
    let today = new Date();
    
    $scope.date = {
        from: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
    };
    $scope.dateOptionsFrom = {
    formatYear: 'yy',
    minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
    startingDay: 1,
        };

    $scope.dateOptionsTo = {
    formatYear: 'yy',
    minDate: $scope.date.from,
    startingDay: 1,
        }   ;

    $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[0];
    $scope.altInputFormats = ['M!/d!/yyyy'];
    $scope.placeUTCOffset = moment
    .tz($scope.place.timezone)
    .format('Z')
    .toString();
    $scope.now = moment().tz($scope.place.timezone).toISOString();
    $scope.datesIsOpen = {
    from: false,
    to: false,
        };
    $scope.hours = [];
    $scope.timeTo = '';
    $scope.timeFrom = '';
    $scope.generateSlots = () => {
        const hours = [];
        for(let hour = 0; hour < 24; hour++) {
            hours.push(moment({ hour }).format('HH:mm'));
            hours.push(
                moment({
                    hour,
                    minute: 15
                }).format('HH:mm')
            );
            hours.push(
                moment({
                    hour,
                    minute: 30
                }).format('HH:mm')
            );
            hours.push(
                moment({
                    hour,
                    minute: 45
                }).format('HH:mm')
            );
        }
        return hours;
    }
    
    $scope.hours = $scope.generateSlots();
    $scope.timeFrom = $scope.hours[0];
    $scope.timeTo = $scope.hours[0];
    $scope.create = () => {
        const modalInstance = $uibModal.open({
            templateUrl: '/templates/components/modals/program-capacity.html',
            size: 'lg',
            controller: 'ProgramCapacityController',
            resolve: {
                areaId: () => $scope.areaId,
            }
        });
        modalInstance.result.then(() => {
            if ($scope.areaId && $scope.alreadyFiltered) {
                $scope.apply();
            }
        })
    }

    $scope.apply = () => {
        $scope.showLoader = true;
        $scope.areaId = $scope.selectedArea._id;
        if (!$scope.areaId) {
            NotificationService.Warning($translate.instant('no_process_warning'));
            $scope.showLoader = false;
            return false;
        }

        const dateFromWithTime = SlotsPerTimeRangeService.GetDateWithTimezone($scope.date.from, $scope.timeFrom, $scope.placeUTCOffset);
        const dateToWithTime = SlotsPerTimeRangeService.GetDateWithTimezone($scope.date.to, $scope.timeTo, $scope.placeUTCOffset);
        const momentFrom = moment(dateFromWithTime);
        const momentTo = moment(dateToWithTime);
        if (momentTo.diff(momentFrom, 'minutes') > 1440) {
            NotificationService.Warning($translate.instant('date_range_too_big_warning'));
            $scope.showLoader = false;
            return false;
        }
        if (momentTo.diff(momentFrom, 'minutes') < 0) {
            NotificationService.Warning($translate.instant('diff_below_zero_warning'));
            $scope.showLoader = false;
            return false;
        }
        if ($scope.previousArea !== $scope.selectedArea._id) {
            $scope.configurations = [];
        }
        $scope.configurations = [];
        const filters = {
            dateFrom: dateFromWithTime,
            dateTo: dateToWithTime,
            areaId: $scope.areaId,
            index: $scope.configurations.length,
        };
        SlotsPerTimeRangeService.GetByFilter(filters).then(data => {
            $scope.previousArea = $scope.areaId;
            data.forEach(elem => {
                $scope.configurations.push(elem);
            });
            $scope.configurations = $scope.sortConfigs($scope.configurations);
            $timeout(() => {
                if ($scope.configurations.length > 0) {
                    $scope.showMoreBtn = true;
                }
                $scope.showLoader = false;
                $scope.applyFilters = true;
                $scope.alreadyFiltered = true;
            });
        });
    }

    $scope.dateChange = () => {
        $scope.dateOptionsTo = {
            formatYear: 'yy',
            minDate: $scope.date.from,
            startingDay: 1,
        };
        $scope.date.to = $scope.date.from;
    }

    $scope.sortConfigs = (configurations) => {
        configurations.sort(function(a,b){
            return new Date(a.dateFrom) - new Date(b.dateFrom);
          });
          return configurations;
    }

    $scope.showMore = () => {
        $scope.showLoader = true;
        const dateFromWithTime = SlotsPerTimeRangeService.GetDateWithTimezone($scope.date.from, $scope.timeFrom, $scope.placeUTCOffset);
        const dateToWithTime = SlotsPerTimeRangeService.GetDateWithTimezone($scope.date.to, $scope.timeTo, $scope.placeUTCOffset);
        
        const filters = {
            dateFrom: dateFromWithTime,
            dateTo: dateToWithTime,
            areaId: $scope.areaId,
            index: $scope.configurations.length,
        };
        SlotsPerTimeRangeService.GetByFilter(filters).then(data => {
            data.forEach(elem => {
                $scope.configurations.push(elem);
            });
            $scope.configurations = $scope.sortConfigs($scope.configurations);
            $timeout(() => {
                $scope.showLoader = false;
            });
        });
    }

    $scope.deleteConfig = (id) => {
        dialog.confirm($translate.instant('delete_configuration_sure'))
        .then(() => {
            SlotsPerTimeRangeService.Remove(id).then(data => {
                if (data) {
                    NotificationService.Success($translate.instant('config_deleted_succefully'));
                    $scope.configurations = [];
                    $scope.apply();
                }
            }).catch(() => {
                NotificationService.Error($translate.instant('default_case'));
              });
        });
    }

    $scope.disableRow = (dateTo) => {
        const now = moment(new Date().toUTCString());
        const date = moment(dateTo);
        const diff = date.diff(now, 'minutes');
        return diff < 0;
    }

    $scope.getFieldClass = function(dateTo){
        const now = moment(new Date().toUTCString());
        const date = moment(dateTo);
        const diff = date.diff(now, 'minutes');
        return diff < 0 ? 'disabled-table-line' : '';
     }

}

module.exports = module.controller('SlotsPerTimeRangeController', SlotsPerTimeRangeController);